import { REWARD_CATEGORY } from './actionTypes';

export const setReduxRewardCategory = (data) => {
  return {
    type: REWARD_CATEGORY,
    data,
  };
};
